import { NavLink } from "react-router-dom";

const BuyingACar = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Buying a Car</h1>

      <p>
        Once you have identified a car you are interested in, here are the steps to participate in the auction:
      </p>

      <ol className="ps-3">
        <li className="mb-3">
          <strong>Register to Bid</strong><br />
          To place bids, you must first create an account with a valid credit card and a verified phone number.
        </li>

        <li className="mb-3">
          <strong>Due Diligence</strong><br />
          While bidding is easy, it is your responsibility to ensure that the car you are bidding for is right for you.
          Consider the cost of ownership, financing options, and whether the vehicle suits your needs.
        </li>

        <li className="mb-3">
          <strong>Review Listings Carefully</strong><br />
          Sellers are required to upload clear images of the car from all angles, list any flaws, and provide a service history with proof.
          It is your duty as a potential buyer to verify these claims and ensure they match the provided information.
        </li>

        <li className="mb-3">
          <strong>Financing</strong><br />
          XLR8 does not currently offer financing. We recommend checking rates from external financing companies or banks.
          Please arrange financing ahead of time if you plan to finance your purchase.
        </li>

        <li className="mb-3">
          <strong>Place Your Bid!</strong><br />
          Once you place a bid, we will hold an authorization charge on your card for the buyer’s fee.
          If you win, your card will be charged, and you will settle payment directly with the seller.
          If not, the hold will be released within 7 days after the auction concludes.
        </li>

        <ul className="ps-4 mt-2 mb-4">
          <li>Bid Increments:</li>
          <ul className="ps-4">
            <li><strong>$50,000 and Below:</strong> $100 increment</li>
            <li><strong>$50,000 to $100,000:</strong> $200 increment</li>
            <li><strong>$100,000 to $200,000:</strong> $500 increment</li>
            <li><strong>$200,000 and Above:</strong> $1,000 increment</li>
          </ul>
        </ul>

        <p>
          All bids are manual and legally binding. There is no proxy bidding.
          The current bid you place will immediately be reflected if it is the highest bid.
          If you back out after winning, a 1% fee of your bid price will be charged to your card.
        </p>

        <p>
          To prevent bid sniping, any new bid placed near the auction end will extend the countdown timer by 1 minute.
        </p>

        <li className="mb-3">
          <strong>Winning the Auction</strong><br />
          You must be the highest bidder and meet the reserve price (if any) to win.
          After the auction ends, buyer and seller contact details will be shared to finalize the transaction.
          Buyers must settle full payment within 7 days.
        </li>

        <li className="mb-3">
          <strong>Buyer on Settlement Day</strong><br />
          If on settlement day the vehicle does not match its listing (due to defects, discrepancies), you may renegotiate with the seller.
          XLR8 is not responsible for negotiations. For major issues, you may refuse to complete the transaction and report it to us via "Chat with Us" with supporting evidence.
        </li>
      </ol>

      <p className="mt-4">
        Once the transaction is complete and ownership has been transferred, kindly update the status to "Sold" via your dashboard.
        This helps us proudly share your successful auction with our community!
      </p>

      <p>
        We highly recommend printing the <strong>Vehicle Auction Sales Agreement Form</strong> available on your dashboard to keep a proper record of the transaction.
      </p>
    </div>
  );
};

export default BuyingACar;
